<app-page-meta pageTitle="finzy - My Loans & Applications"></app-page-meta>

<div class="row d-flex justify-content-center align-items-center">
  <div class="col-lg-9 col-md-10 col-sm-11 col-xs-12 text-center all-loans-and-applications-main-cont">
    <app-display-picture [userId]="user._id"></app-display-picture>

    <p class="text-color-finzy-blue font-largest mt-2 font-weight-bold">
      <span appDottedLoader [appShowLoaderUntil]="user.name">{{ user.name | titlecase }}</span>
    </p>

    <ng-container>
      <span *ngIf="canReapplyForLoan && !preApprovedLoanOfferCard">
        <p class="my-4 font-normal">You can now apply for another loan!</p>
        <span class="font-weight-bold">
          <button mat-flat-button class="primary" (click)="navigateToLoanInfo()">
            APPLY NOW
          </button>
        </span>
      </span>
    </ng-container>

    <div *ngIf="preApprovedLoanOfferCard">
      <div class="border-green d-flex p-5 rounded pl-lg-4 pl-md-4 pl-sm-4 pt-lg-4 pb-lg-4 pt-sm-4 pb-sm-4">
        <div class="w-100 p-0 pre-approved-display-flex align-items-center">
          <div class="col-lg-1 col-xs-12 p-0 mr-4">
            <img src="../../assets/images/borrower-dashboard/{{preApprovedLoanOfferCard.image}}" alt="Pre-approved loan offer" class="pre-approved-loan-img">
          </div>
          <div class="col-lg-9 col-xs-12 text-left p-0  m-b3">
            <h4 class="font-weight-bold text-color-finzy-blue m-0 text-center pre-approved-content-left">{{ preApprovedLoanOfferCard.header }}</h4>
            <div class="align-items-center d-flex flex-wrap justify-content-center  pre-approved-content-left mt-2">
              <span class="font-weight-bold mr-1">{{ preApprovedLoanOfferCard.description }}</span>
              <i class="quick-cash-logo mr-1 mt-1"></i>
              <app-tooltip placement="top" class="mr-1 mt-1">
                <i style="font-size: 12px;" class="infoIcon material-icons d-flex" trigger>info_outline</i>
                <div content>
                  <div class="row d-flex flex-wrap flex-lg-nowrap flex-lg-column flex-sm-column text-left ml-3 mr-3 align-items-center">
                    <div class="d-flex flex-wrap">
                      <i class="quick-cash-logo mr-1" style="margin-top: 4px;"></i>
                      <span>allows easy and quick</span>
                    </div>
                    <span>access to funds directly credited to</span>
                    <span>your bank account.</span>
                  </div>
                </div>
              </app-tooltip>
              <span class="font-weight-bold"> line</span>
            </div>
            <div *ngIf="preApprovedLoanOffer" class="d-flex flex-column mt-2 flex-lg-row flex-md-row justify-content-center  pre-approved-content-left">
              <div class="d-flex flex-wrap border-right align-items-center pr-3 pr-md-2 padding-right justify-content-center">
                <span class="mr-1">Line Amount</span>
                <app-tooltip placement="top" class=" mt-1">
                  <i style="font-size: 12px;" class="infoIcon material-icons d-flex" trigger>info_outline</i>
                  <div content class="align-items-center">
                    <div class="align-items-center ml-3 mr-3" style="max-width: 243px;">
                      Sanctioned amount of overall credit limit at finzy
                    </div>
                  </div>
                </app-tooltip><span class="mr-2">:</span>
                <div class="pre-approved-offer-eligibility-numbers-cont">
                  <span class="text-color-finzy-green">₹</span>
                  <span class="font-weight-bold text-color-finzy-green">{{ preApprovedLoanOffer.loanAmount | number : '1.2-2' }}</span>
                </div>
              </div>
              <div class="text-color-light-grey d-none d-lg-block d-md-block">|</div>
              <div class="d-flex flex-wrap border-right align-items-center justify-content-center pl-3 pr-3 pl-md-2 pr-md-2 padding-left padding-right">
                <span class="mr-1">Outstanding Amount</span>
                <app-tooltip placement="top" class=" mt-1">
                  <i style="font-size: 12px;" class="infoIcon material-icons d-flex" trigger>info_outline</i>
                  <div content class="align-items-center">
                    <div class="align-items-center ml-3 mr-3" style="max-width: 274px;">
                      Cumulative outstanding amount across all (availed and in-process) loans
                    </div>
                  </div>
                </app-tooltip><span class="mr-2">:</span>
                <div class="pre-approved-offer-eligibility-numbers-cont text-color-finzy-green">
                  <span>₹</span>
                  <span class="font-weight-bold">{{ (outstandingEligibilityCheck.totalPrincipalOutstandingOfDisbursedLoans
                          + outstandingEligibilityCheck.totalLoanAmountOfYetToBeDisbursedLoans) | number : '1.2-2' }}</span>
                </div>
              </div>
              <div class="text-color-light-grey d-none d-lg-block d-md-block">|</div>
              <div class="d-flex flex-wrap border-right align-items-center pl-3 pl-md-2 padding-left justify-content-center">
                <span class="mr-1">Withdrawable Amount</span>
                <app-tooltip placement="top" class=" mt-1">
                  <i style="font-size: 12px;" class="infoIcon material-icons d-flex" trigger>info_outline</i>
                  <div content class="align-items-center">
                    <div class="align-items-center ml-3 mr-3" style="max-width: 274px;">
                      Dynamic line available for withdrawal that changes as you withdraw amount or repay the loans via prepayment or through EMIs
                    </div>
                  </div>
                </app-tooltip><span class="mr-2">:</span>
                <div class="pre-approved-offer-eligibility-numbers-cont" [ngClass]="outstandingEligibilityCheck?.isValid ? 'text-color-finzy-green' : 'text-color-finzy-orange' ">
                  <span>₹</span>
                  <span class="font-weight-bold">{{ outstandingEligibilityCheck.eligibleLoanAmount | number : '1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-sm-12 col-xs-12 p-0 m-0 mt-0 mt-sm-4 mb-0 mb-sm-3 pre-approved-display-flex pre-approved-apply-now-cont">
            <button [disabled]="!outstandingEligibilityCheck?.isValid" mat-flat-button class="primary p-0 m-0" (click)="availPreApprovedLoanOffer()">APPLY NOW</button>
          </div>
        </div>
      </div>
      <div class="txt-left mt-3 mb-5 text-color-darker-grey">
        <div class="d-flex flex-wrap align-items-center justify-content-center pre-approved-content-left">
          <span class="mr-1">Minimum amount that can be availed from</span>
          <i class="quick-cash-logo mt-2 mr-1"></i>
          <app-tooltip placement="top" class="mr-1 mt-1">
            <i style="font-size: 12px;" class="infoIcon material-icons d-flex" trigger>info_outline</i>
            <div content>
              <div class="row d-flex flex-wrap flex-lg-nowrap flex-lg-column flex-sm-column text-left ml-3 mr-3 align-items-center">
                <div class="d-flex flex-wrap">
                  <i class="quick-cash-logo mr-1" style="margin-top: 4px;"></i>
                  <span>allows easy and quick</span>
                </div>
                <span>access to funds directly credited to</span>
                <span>your bank account.</span>
              </div>
            </div>
          </app-tooltip>
          <span class="mr-1">line is </span>
          <div  [ngClass]="outstandingEligibilityCheck && !outstandingEligibilityCheck.isValid ? 'text-color-finzy-orange' : 'text-color-black' ">
            <span>₹</span>
            <span class="font-weight-bold mr-1">{{ minimumLoanAmount | number : '1.2-2' }}</span>
          </div>
          <div>
            <span>and hereafter in multiples of ₹</span>
            <span class="font-weight-bold mr-1 text-color-black">{{ loanAmountDenomination | number : '1.2-2'}}</span>
          </div>
        </div>
        <div class="d-flex flex-wrap justify-content-center pre-approved-content-left mt-1">
          <span class="mr-1">You may also apply for a higher loan amount </span>
          <a class="link-default mr-1" (click)="navigateToLoanInfo()"> click here</a>
          <span>(subject to credit approval)</span>
        </div>
        <div class="d-flex flex-wrap justify-content-center pre-approved-content-left mt-1 mb-5">
          <span class="mr-1 font-bold">Note : </span>
          <span class="text-color-black">Additional documentation may be necessary for KYC or Credit purposes following the final assessment</span>
        </div>
      </div>
    </div>

    <div class="background-gray mt-4 p-5 rounded">
      <div class="row d-lg-flex align-items-center">
        <div class="col-sm-12 col-md-8 text-left">
          <h4 class="font-weight-bold txt-center">You can pay EMIs or Part/Full Prepay your loan</h4>
          <ng-container *ngIf="user.loan_details;else singleLoan">
            <ng-container *ngIf="user.loan_details.length > 1;else singleLoan">
              <p class="txt-center m-b3">
                Please reach at
                <a href="mailto:support@finzy.com" target="_blank">support@finzy.com,</a>
                to know the exact foreclosure amount, penal interest
                and charges for the delayed EMIs (if any) or If you are
                making a single fund transfer towards multiple EMIs or prepayments.
              </p>
            </ng-container>
          </ng-container>
          <ng-template #singleLoan>
            <span>
              Please reach at
              <a href="mailto:support@finzy.com" target="_blank">support@finzy.com,</a>
              to know the exact foreclosure amount, penal interest
              and charges for the delayed EMIs (if any).
            </span>
          </ng-template>
        </div>

        <div class="col-sm-12 col-md-4 my-2">
          <button id="pay-emi" mat-flat-button class="primary mx-4" (click)="prePartyPayHandler()">
            PREPAY
          </button>
          <button mat-flat-button class="primary" (click)="payYourEmiHandler()">
            PAY EMI
          </button>
        </div>
      </div>

    </div>

    <div class="mt-4 p-5 rounded border">
      <div class="row d-lg-flex align-items-center">
        <div class="col-sm-12 col-md-8 text-left">
          <h4 class="font-weight-bold txt-center">Loans with suggested terms</h4>
          <p>You can view all your loans with suggested terms by clicking view all here</p>
        </div>

        <div class="col-sm-12 col-md-4 my-2 text-end">
          <button mat-flat-button class="primary" [routerLink]="['/borrow/dashboard/loan-suggested-term']">
            View All
          </button>
        </div>
      </div>

    </div>

    <app-active-application class="my-4" [userId]="user._id"></app-active-application>

    <mat-tab-group class="mb-5" [disableRipple]="true">
      <mat-tab label="Pending Applications">
        <ng-template matTabContent>
          <app-all-in-progress-loan-applications [userId]="user._id"></app-all-in-progress-loan-applications>
        </ng-template>
      </mat-tab>

      <mat-tab label="All Loans">
        <!-- Lazily load the contents of Tab, follow the same for Closed Loan(s) Tab -->
        <ng-template matTabContent>
          <app-all-loans [userId]="user._id"></app-all-loans>
        </ng-template>

      </mat-tab>

      <mat-tab label="Past Applications">
        <ng-template matTabContent>
          <app-past-applications [userId]="user._id"></app-past-applications>
        </ng-template>
      </mat-tab>
      
      <mat-tab label="Online Payment History">
        <ng-template matTabContent>
          <app-material-table
                  [dataSource]="userTransactions"
                  [tableHeader]="tableHeader"
                  [displayedColumns]="displayedColumns"
          >
          </app-material-table>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
